<ion-header>
  <ion-toolbar>
    <ion-title>Confirmar pago</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding" size="12">
        <!-- <ion-text color="medium">
          <p class="ion-padding-horizontal ion-text-center">Confirma tu Compra</p>
        </ion-text> -->
      </ion-col>
      <ion-col size="12">
        <app-boards
          *ngIf="tickets.length"
          option="purchase"
          [tickets]="tickets"
          [isModal]="false"
          [gameType]="type"
          [isResume]="true"
          [isCoperacha]="isCoperacha"
          [touches]="touches"
          [trackingS]="tracking"
        ></app-boards>
      </ion-col>

      <ion-col size="12" *ngIf="type === 'prono-sports'">
        <div [innerHTML]="formatTicketData(tickets) | safeHtml"></div>
        <div class="disclaimer-box">
          <ion-icon name="warning" class="warning-icon"></ion-icon>
          <p class="disclaimer">
            Este monto máximo a ganar es en base a los momios actuales por lo que te recordamos que este producto es
            dinámico y los momios o estatus de partidos pueden cambiar en cualquier momento.
          </p>
        </div>
      </ion-col>

      <!-- <ion-col class="ion-no-padding" size="12">
        <ion-text color="primary">
          <h3 class="ion-padding-horizontal ion-text-center">
            El monto total es <strong>{{ amount | currency }}</strong>
          </h3>
        </ion-text>
      </ion-col> -->
    </ion-row>
    <!-- <ion-row class="ion-no-padding">
        <ion-col size="12" class="ion-no-padding">
          <ion-item lines="none">
            <ion-toggle (ionChange)="changeRemember($event)">No volver a preguntar</ion-toggle>
          </ion-item>
        </ion-col>
      </ion-row> -->
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="4">
          <ion-button (click)="close()" expand="block" shape="round" color="medium"> <small>Editar</small> </ion-button>
        </ion-col>
        <ion-col size="8">
          <ion-button (click)="acceptPayment()" expand="block" shape="round" color="primary">
            Pagar: {{ amount | currency }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
